import React from 'react';
import { Box, Typography } from '@mui/material';
const Blog = () => {
    return (
        <Box sx={{padding:'1em'}}>
        <Typography variant='h3'>Blog</Typography>
        <Typography variant='p'>Supreme Supplies goes beyond just products. We're your complete solution for keeping your business or home running smoothly. We offer a vast selection of high-quality supplies, from essential office equipment and cleaning products to convenient breakroom essentials and secure packaging materials.  Our commitment extends to exceptional customer service, with friendly staff ready to assist you.  Whether you need bulk discounts for your business or fast delivery to meet a deadline, Supreme Supplies offers flexible options to fit your needs. Visit us today and experience the difference – we're more than just a supplier, we're your partner in success</Typography>
        </Box>
    );
};

export default Blog;